import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import { AnalyticsIcon, MonitorIcon, UnderstandingIcon } from '@segment/matcha/components/Icons/Brandbook'

import IconWrapper from '@segment/matcha/components/IconWrapper'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import WhatIsACustomerDataImage from './WhatIsACustomerDataImage'

const copy = {
  heading: `What is first-party data?`,
  description: `Every marketing and analytics app runs on the same three types of data: who your users are, what they are doing, and where they are when they're doing it. Collect it all at once with Segment and send it to any tool.`,
}

const featured = [
  {
    title: `Track`,
    description: `Track how your users interact with your product like purchasing items, viewing a page, or using a feature.`,
    icon: <AnalyticsIcon />,
  },
  {
    title: `Identify`,
    description: `Identify users to determine if they're new or existing customers, and tie each person to the right actions.`,
    icon: <UnderstandingIcon />,
  },
  {
    title: `Page`,
    description: `Locate users so you know what page they were on and what device they were using when they performed the action.`,
    icon: <MonitorIcon />,
  },
]

const CreateSharedData = () => {
  const theme = useTheme()
  return (
    <>
      <SectionComponent variant="centered">
        <Section.Copy>
          <CopyTextBase centered={true}>
            <CopyText.Heading tag="h2" variant="h2">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description tag="p" variant="pLarge">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
      </SectionComponent>
      <SectionBase variant="2Col" copyVariant="narrow">
        <StyledSectionCopy>
          <CopyTextBase>
            <ColumnTrack gap="small">
              {featured.map((feature) => (
                <FeatureBoxBase headerPosition="left" alignment="left" key={feature.title}>
                  <FeatureBox.Header>
                    <IconWrapper
                      variant="circle"
                      background="white"
                      elevation={1}
                      tokens={{ color: theme.palette.twilio.gray[100] }}
                    >
                      {feature.icon}
                    </IconWrapper>
                  </FeatureBox.Header>
                  <FeatureBox.Body>
                    <FeatureBox.Title>{feature.title}</FeatureBox.Title>
                    <FeatureBox.Text>{feature.description}</FeatureBox.Text>
                  </FeatureBox.Body>
                </FeatureBoxBase>
              ))}
            </ColumnTrack>
          </CopyTextBase>
        </StyledSectionCopy>
        <Section.Contents>
          <WhatIsACustomerDataImage />
        </Section.Contents>
      </SectionBase>
    </>
  )
}

const SectionComponent = styled(SectionBase)`
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-top: 80px;
    }
    padding-bottom: 0;
    row-gap: 0;
  }
`

const StyledSectionCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
  }
  justify-self: end;
`

export default CreateSharedData
